import cookieNames from './cookieNames'


const specialFlowCookies = [
  cookieNames.selectedPlan,
  cookieNames.discountCoupon,
  cookieNames.priceWithDiscount,
]

export default specialFlowCookies
